import React from "react";

interface Options {
  enabled: "onlyV1" | "onlyV2" | "v1AndV2"
  modernLabel: string // e.g. "Online invoice", "eSign"
  legacyLabel: string // "Classic workflow"
}

export type UseModernOrLegacyHook = ReturnType<typeof useModernOrLegacy>;

const useModernOrLegacy = (options: Options) => {
  const [screen, setScreen] = React.useState<"chooseLegacyOrModernScreen" | "minimalCreationScreen" | "redirectToLegacy">(undefined);

  const displayModernOrLegacy = () => {
    if (options.enabled === "onlyV1") {
      setScreen("redirectToLegacy");
    }
    else if (options.enabled === "v1AndV2") {
      setScreen("chooseLegacyOrModernScreen");
    }
    else {
      setScreen("minimalCreationScreen");
    }

  }

  const onModernSelected = async () => {
    setScreen("minimalCreationScreen");
  };

  return {
    screen,
    onClose: () => setScreen(undefined),
    displayModernOrLegacy,
    onModernSelected,
    modernLabel: options.modernLabel,
    legacyLabel: options.legacyLabel,
    enabled: options.enabled
  }
}

export const useInvoiceV2OrLegacy = () => {
  let invoiceV2Enabled: "onlyV1" | "onlyV2" | "v1AndV2";

  switch (site.currentEnvironment.invoice.enabled) {
    case "onlyV1": invoiceV2Enabled = "onlyV1"; break;
    case "onlyV2": invoiceV2Enabled = "onlyV2"; break;
    case "v1AndV2": invoiceV2Enabled = "v1AndV2"; break;
  }

  return useModernOrLegacy({
    enabled: invoiceV2Enabled,
    modernLabel: `${RESX.InvoiceDocument.Invoice} V2`,
    legacyLabel: RESX.ESign.ClassicWorkflow,
  })
}

export const useEsignOrLegacy = () => {
  let esignEnabled: "onlyV1" | "onlyV2" | "v1AndV2";

  switch (site.currentEnvironment.eSignEnabled) {
    case "onlyLegacy": esignEnabled = "onlyV1"; break;
    case "onlyESign": esignEnabled = "onlyV2"; break;
    case "legacyAndESign": esignEnabled = "v1AndV2"; break;
  }

  return useModernOrLegacy({
    enabled: esignEnabled,
    modernLabel: RESX.ESign.eSign,
    legacyLabel: RESX.ESign.ClassicWorkflow,
  })
}